let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5d5n9")).then(() => parcelRequire('4DJNq'));